import { FC } from "react"
import { useTranslation } from "react-i18next"
import { Link, Navigate, useLocation } from "react-router-dom"
import { HomeBgImg, LogoBigImg } from "@/assets"
import { useAppSelector } from "@/store"
import { PlayerSelectors } from "@/store/slices/player"
import {
  EmailOtpForm,
  GoogleAuthButton,
  TelegramAuthButton,
  YandexAuthButton
} from "@/ui/auth"
import styles from "./Login.module.scss"

export const Login: FC = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const isAuthorized = useAppSelector(PlayerSelectors.selectIsAuthorized())

  if (isAuthorized) return <Navigate to="/" replace />

  const prefillEmail = (location.state as { prefillEmail?: string } | null)
    ?.prefillEmail

  return (
    <div className={styles.Login}>
      <img src={HomeBgImg} alt="background" className={styles.Login_bg} />
      <img src={LogoBigImg} alt="logo" className={styles.Login_logo} />
      <div className={styles.Login_title}>{t("login.title")}</div>

      <div className={styles.Login_providers}>
        <EmailOtpForm mode="login" initialEmail={prefillEmail} />

        <div className={styles.Login_divider}>
          <span>{t("login.or")}</span>
        </div>

        <div className={styles.Login_providersFast}>
          <TelegramAuthButton mode="login" />
          <GoogleAuthButton mode="login" />
          <YandexAuthButton mode="login" />
        </div>
      </div>

      <div className={styles.Login_footer}>
        {t("login.noAccount")}
        <Link to="/register" className={styles.Login_footer_link}>
          {t("login.registerCta")}
        </Link>
      </div>
    </div>
  )
}
